import React from 'react'

import Link from 'components/ui/Link/Link'
import Image from 'components/_new/ui/Image/Image'

import s from './ProductCard.scss'


const ProductCard = ({ img, image, url, name }) => (
  <div className={s.root}>
    <Link className={s.imgPreviewWrapper} to={url}>
      <Image className={s.imgPreview} src={img || image} w={100} alt={name} x2 x3 />
    </Link>
    <Link className={s.title} to={url} blackColor>{name}</Link>
  </div>
)


export default ProductCard
